module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-34.91a948cd.png";